/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import {
  Col,
  Dropdown,
  FlexContainer,
  Label,
  Row,
  theme,
} from "@nordcloud/gnui";
import { Option } from "~/models";

const SelectWrap = styled.div`
  border-top: 1px solid ${theme.color.border.border01};
  width: 100%;
  margin-top: ${theme.spacing.spacing04};
  padding-top: ${theme.spacing.spacing04};
`;

type Props = {
  yearOptions: string[];
  monthOptions: Option[];
  monthValue: string;
  yearValue: string;
  onMonthChange: (value: string) => void;
  onYearChange: (value: string) => void;
};

export function BillingPeriodSelector({
  yearOptions,
  monthOptions,
  monthValue,
  yearValue,
  onMonthChange,
  onYearChange,
}: Props) {
  return (
    <SelectWrap>
      <Label required name="Select Billing Period" />
      <FlexContainer>
        <Row>
          <Col sm={2}>
            <Dropdown
              name="year"
              value={yearValue}
              options={yearOptions}
              onChange={onYearChange}
            />
          </Col>
          <Col>
            <Dropdown
              name="Select Month..."
              value={monthValue}
              options={monthOptions}
              onChange={onMonthChange}
            />
          </Col>
        </Row>
      </FlexContainer>
    </SelectWrap>
  );
}
